import {
  errorMessagesSection,
  FormStyle,
  infoPlaceholderSection,
  React,
} from "@/imports-files/components/custom-select";
import { Editor } from "@tinymce/tinymce-react";
import { useTranslation } from "react-i18next";

export function CustomEditor(props) {
  const { i18n } = useTranslation();
  const localeMap = {
    en: "en_US",
    sv: "sv_SE",
    da: "da",
    no: "nb_NO",
  };
  const getTinyMCELanguage = (language) => localeMap[language] || "en_US";
  const errorStyles = props.InputError?.(props.formik, props.name) || {};
  const inputStyles = props.style || {};
  return (
    <div
      className={
        props.style
          ? `text_editor_error_container ${props.identifierClass || ""}`
          : `text_editor_container ${props.identifierClass || ""}`
      }
    >
      <Editor
        apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
        onInit={props.onInit}
        textareaName={props.textareaName}
        id={props.id}
        value={props.value}
        onEditorChange={props.onEditorChange}
        init={{
          ...props.init,
          language: getTinyMCELanguage(i18n.language),
        }}
        disabled={props.disabled}
        key={props.key}
      />
      {props.style != undefined
        ? errorMessagesSection(props.textareaName, FormStyle, props.formik)
        : infoPlaceholderSection(props.infoPlaceholder, FormStyle)}
    </div>
  );
}
